export const STATES = ['offer', 'negotiation', 'contracted', 'ready', 'in_progress', 'completed', 'accepted', 'closed', 'lost', 'cancelled'] as const
export type State = typeof STATES[number]
export const REASONS = ['permit', 'client', 'material', 'design', 'weather', 'crew', 'other'] as const
export type Reason = typeof REASONS[number]

export interface Segment { state: State; from: string; to: string; days: number; blockedDays: number; source: 'derived' | 'manual' }
export interface EventView { id: number; state: State; at: string; note: string | null; byName: string | null; createdAt: string }
export interface BlockView { id: string; startsOn: string; endsOn: string | null; reason: Reason; note: string | null; byName: string | null }
export interface PlanView {
  contractValue: number | null; startOn: string | null; endOn: string | null; activationOn: string | null; acceptanceOn: string | null
  hp: number | null; hpPlus: number | null; ha: number | null; trenchM: number | null; sources: Record<string, 'app' | 'au'>
}
export interface RevenueLine { group: string; type: string; invoices: number; net: number }
export interface RevenueView {
  invoiced: number; paid: number; owed: number; unknown: number; invoices: number
  firstInvoice: string | null; finalInvoice: string | null; paidAsOf: string | null; lines: RevenueLine[]
}
export interface OutputLine { kind: string; surface: string | null; quantity: number | null; planned: number | null }
export interface ProjectExecution {
  projectId: string; name: string | null; code: string | null; provider: string | null
  state: State | null; stateSince: string | null; daysInState: number; derived: boolean; blockedNow: BlockView | null; idleDays: number | null
  timeline: Segment[]; events: EventView[]; blocks: BlockView[]; plan: PlanView
  actuals: { firstWorked: string | null; lastWorked: string | null; crewDays: number; manHours: number; daysLate: number | null }
  revenue: RevenueView; output: OutputLine[]
}
export interface PortfolioRow {
  projectId: string; name: string | null; code: string | null; provider: string | null
  state: State | null; stateSince: string | null; daysInState: number; derived: boolean; blockedReason: Reason | null; blockedDays: number; idleDays: number | null
  plannedEnd: string | null; daysLate: number | null; contractValue: number | null; invoiced: number; paid: number; owed: number
  trenchM: number; ha: number; hp: number; hpPlus: number; nha: number; lastWorked: string | null
}
export interface Portfolio {
  rows: PortfolioRow[]
  funnel: { state: State; projects: number; contractValue: number; blocked: number; idle: number }[]
  timeInState: { state: State; finished: number; medianDays: number | null; p75Days: number | null; medianNetDays: number | null; ongoing: number; ongoingMedianDays: number | null }[]
  paidAsOf: string | null; invoiced: number; paid: number; owed: number; output: OutputLine[]
}
